import React from 'react';
import { SkeletonCol, SkeletonItem, SkeletonRow } from './styles';
import { SkeletonProps } from './types';

const DEFAULT_HEIGHT = '80px';

/**
 * Skeleton
 * @param totalCols Number of columns of the total skeleton grid. Default: 24
 * @param globalGap Global value to set as default for columnGap, rowGap and marginBottom in pixels. Default:16
 * @param skeleton Array of rows of the skeleton grid
 * @param skeleton[].height Default: 80px
 * @param skeleton[].repeat Number of consecutive rows to render with this same configuration
 * @param skeleton[].marginBottom Default: 16
 * @param skeleton[].align
 * @param skeleton[].rowGap Gap between items of current row. Default: 16
 * @param skeleton[].columns Array of columns for the current row
 * @param skeleton[].columns[].columnGap Gap between items of current column. Default: 16
 * @param skeleton[].columns[].repeat Number of consecutive columns to render with this same configuration
 * @param skeleton[].columns[].width
 * @param skeleton[].columns[].widthInCols Number of grid columns this column occupies
 * @param skeleton[].columns[].align
 * @param skeleton[].columns[].items Array of elements for the current column
 * @param skeleton[].columns[].items[].shape circle or rectangle
 * @param skeleton[].columns[].items[].height
 */
const Skeleton: React.FC<SkeletonProps> = ({ totalCols = 24, skeleton, globalGap = 16 }) => (
  <>
    {skeleton.map((row) =>
      Array.from(Array(row.repeat).keys()).map(() => (
        <SkeletonRow
          cols={totalCols}
          height={row.height || DEFAULT_HEIGHT}
          marginBottom={row.marginBottom || globalGap}
          align={row.align}
          gutter={row.rowGap || globalGap}
        >
          {row.columns.map((column) =>
            Array.from(Array(column.repeat).keys()).map(() => (
              <SkeletonCol
                xxs={column.widthInCols}
                gap={column.columnGap || globalGap}
                align={column.align}
              >
                {column.items.map((item) => (
                  <SkeletonItem
                    rounded={item.shape === 'circle'}
                    height={item.height}
                    width={item.shape === 'circle' ? row.height || DEFAULT_HEIGHT : column.width}
                  />
                ))}
              </SkeletonCol>
            )),
          )}
        </SkeletonRow>
      )),
    )}
  </>
);

export default Skeleton;
